document.addEventListener('DOMContentLoaded', () => {
  const pillsWrap = document.querySelector('[data-bm-shop-filter]');
  const grid = document.querySelector('[data-bm-shop-grid]');
  if (!pillsWrap || !grid) return;

  const pills = Array.from(pillsWrap.querySelectorAll('[data-bm-filter]'));
  const typeSelect = pillsWrap.querySelector('[data-bm-type-filter]');
  const items = Array.from(grid.querySelectorAll('[data-bm-cats]'));
  const countEl = pillsWrap.querySelector('[data-bm-shop-count]');
  const noun = pillsWrap.getAttribute('data-bm-count-noun') || 'printables';

  let activeCategory = pillsWrap.getAttribute('data-bm-initial-filter') || 'all';
  let activeType = 'all';

  function applyFilters() {
    let visible = 0;
    items.forEach((item) => {
      const cats = (item.getAttribute('data-bm-cats') || '').split(' ').filter(Boolean);
      const type = item.getAttribute('data-bm-type') || '';
      const matchesCategory = activeCategory === 'all' || cats.includes(activeCategory);
      const matchesType = activeType === 'all' || type === activeType;
      const show = matchesCategory && matchesType;
      item.hidden = !show;
      if (show) visible += 1;
    });
    pills.forEach((pill) => {
      pill.classList.toggle('is-active', pill.getAttribute('data-bm-filter') === activeCategory);
    });
    if (countEl) countEl.textContent = `${visible} ${noun}`;
  }

  pills.forEach((pill) => {
    const value = pill.getAttribute('data-bm-filter');
    if (value === null) return; // links out (e.g. "The binder") — no client filter
    pill.addEventListener('click', (event) => {
      event.preventDefault();
      activeCategory = value;
      applyFilters();
    });
  });

  if (typeSelect) {
    typeSelect.addEventListener('change', () => {
      activeType = typeSelect.value;
      applyFilters();
    });
  }

  applyFilters();
});
